import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/categories';
import { articles, faqs } from '@/mocks/articles';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const featuredArticles = articles.slice(0, 6);

  return (
    <>
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '女仆教育',
          url: 'https://maid-edu.com/',
          description: '专业女仆培训教育机构，提供系统化的女仆职业培训课程体系、礼仪规范、服务技能与就业方向指导',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://maid-edu.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }}
      />
      {/* Hero Section */}
      <section className="relative h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20training%20room%20with%20warm%20cream%20walls%20and%20dark%20wood%20flooring%2C%20vintage%20tea%20set%20on%20polished%20wooden%20table%2C%20soft%20diffused%20natural%20light%20from%20large%20windows%20with%20sheer%20curtains%2C%20delicate%20floral%20arrangement%2C%20classic%20European%20mansion%20interior%20aesthetic%2C%20refined%20atmosphere%2C%20editorial%20photography%20quality&width=1920&height=1080&seq=hero-maid-01&orientation=landscape"
            alt="女仆教育培训"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
            从零开始，<br className="md:hidden" />成为专业女仆
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            系统化的女仆职业培训课程体系，涵盖礼仪规范、服务技能、职业发展与行业知识，<br className="hidden md:block" />
            助力每一位有志之士实现专业女仆的职业梦想
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/liyi-guifan"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-all cursor-pointer"
            >
              浏览课程
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3 rounded-full border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all cursor-pointer"
            >
              了解我们
            </Link>
          </div>
        </div>
      </section>

      {/* Category Cards */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              课程体系
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              四大核心课程模块，从基础到进阶，构建完整的女仆职业知识体系
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-100 rounded-xl p-5 md:p-6 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                  <i className={`${cat.icon} text-primary-500 text-xl md:text-2xl group-hover:text-background-50 transition-colors`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>查看课程</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                精选文章
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                专业的行业知识与实用技巧分享
              </p>
            </div>
            <Link
              to="/category/liyi-guifan"
              className="whitespace-nowrap text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
            >
              浏览全部文章 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {featuredArticles.map((article) => {
              const cat = categories.find((c) => c.slug === article.category);
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all cursor-pointer"
                >
                  <div className="h-44 md:h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-3 mb-3">
                      {cat && (
                        <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium">
                          {cat.name}
                        </span>
                      )}
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-time-line"></i>
                      <span>{article.readTime} 阅读</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              以专业的教育理念和完善的培训体系，助力每一位学员成为优秀的女仆人才
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              { num: '2000+', label: '累计培养学员', icon: 'ri-group-line' },
              { num: '92%', label: '学员就业率', icon: 'ri-briefcase-line' },
              { num: '50+', label: '合作企业', icon: 'ri-building-line' },
              { num: '8年', label: '教学经验', icon: 'ri-calendar-check-line' },
            ].map((stat, i) => (
              <div key={i} className="text-center p-5 md:p-6 rounded-xl bg-background-100">
                <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${stat.icon} text-primary-500 text-lg`}></i>
                </div>
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                  {stat.num}
                </div>
                <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              关于女仆培训课程，您可能关心的几个问题
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-xl overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform duration-200 flex-shrink-0 ${
                      openFaq === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openFaq === i && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-primary-500">
        <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            准备好开启您的女仆职业之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8">
            立即报名参加我们的专业培训课程，迈出成为专业女仆的第一步
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3 rounded-full bg-background-50 text-primary-600 text-sm md:text-base font-medium hover:bg-background-100 transition-all cursor-pointer"
            >
              立即报名
            </Link>
            <a
              href="tel:400-888-9999"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3 rounded-full border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all cursor-pointer"
            >
              咨询电话：400-888-9999
            </a>
          </div>
        </div>
      </section>
    </>
  );
}